export const SIO_URL = process.env.REACT_APP_SIO_URL || "http://localhost:5501";

export const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";